export default "__VITE_ASSET__DTeqcHSW__"